var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Directive } from "@angular/core";
import { WillyWonka } from "../../../utils/chocolate/willy-wonka";
var DatagridWillyWonka = (function (_super) {
    __extends(DatagridWillyWonka, _super);
    function DatagridWillyWonka() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DatagridWillyWonka;
}(WillyWonka));
export { DatagridWillyWonka };
DatagridWillyWonka.decorators = [
    { type: Directive, args: [{
                selector: "clr-datagrid"
            },] },
];
/** @nocollapse */
DatagridWillyWonka.ctorParameters = function () { return []; };
//# sourceMappingURL=datagrid-willy-wonka.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/datagrid/chocolate/datagrid-willy-wonka.js
// module id = 82
// module chunks = 4